import React, { useEffect, useState } from 'react'

import { Box, Divider, Text } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import { ChevronDown, ChevronUp } from '@factorialco/f0-react/icons/app'
import { AnimatePresence } from 'framer-motion'

interface Props {
  title: string
  divider?: boolean
  collapsible?: boolean
  children: React.ReactNode
  defaultCollapsed?: boolean
  noGap?: boolean
}

const FormBlock = ({
  title,
  divider = true,
  collapsible = false,
  defaultCollapsed = false,
  children,
  noGap = false,
}: Props) => {
  const [open, setOpen] = useState(!defaultCollapsed)

  useEffect(() => {
    setOpen(!defaultCollapsed)
  }, [defaultCollapsed])

  return (
    <Box gap={noGap ? 's0' : 's16'}>
      <Box
        onClick={() => setOpen(!open)}
        aria-label={'See full breakdown'}
        flexDirection="row"
        justifyContent="spaceBetween"
        alignItems="center"
      >
        <Box paddingTop="s6">
          <Text.Normal size="200" weight="medium" color="grey1000">
            {title}
          </Text.Normal>
        </Box>

        {collapsible && <F0Icon size="lg" icon={open ? ChevronUp : ChevronDown} />}
      </Box>

      <Box paddingY="s12">
        <Divider vertical={false} />
      </Box>
      <AnimatePresence>
        {(!collapsible || open) && (
          <Box.Motion
            flexDirection="column"
            gap="s16"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
          >
            {children}
          </Box.Motion>
        )}
      </AnimatePresence>
      {divider && (
        <Box paddingTop="s16" paddingBottom="s16">
          <Divider vertical={false} />
        </Box>
      )}
    </Box>
  )
}

export default FormBlock
